export default "__VITE_ASSET__RODjtg9Z__"